import { components } from "@appretio/api";

/**
 * All the available context fields that can be requested
 */
export type ContextField = components["schemas"]["ContextField"];

/**
 * Represents a single context option as displayed in the
 * context selector dropdowns
 */
export interface ContextOption {
  displayName: string;
  displayOrder: number;
}

/**
 * Mapping between available context fields and display name and orders
 */
export const contextOptions: Record<ContextField, ContextOption> = {
  brand: { displayName: "Brand", displayOrder: 1 },
  sub_brand: { displayName: "Sub-brand", displayOrder: 2 },
  product_line: { displayName: "Product line", displayOrder: 3 },
  collection_type: { displayName: "Col type", displayOrder: 4 },
  product_category: { displayName: "Product Category", displayOrder: 5 },
  collection_name: { displayName: "Collection", displayOrder: 6 },
  country: { displayName: "Country", displayOrder: 7 },
  sales_location: { displayName: "Location", displayOrder: 8 },
  chain: { displayName: "Chain", displayOrder: 9 },
  channel: { displayName: "Channel", displayOrder: 10 }
};
